(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@tsed/core"), require("@tsed/schema"));
	else if(typeof define === 'function' && define.amd)
		define(["@tsed/core", "@tsed/schema"], factory);
	else if(typeof exports === 'object')
		exports["@tsed/json-mapper"] = factory(require("@tsed/core"), require("@tsed/schema"));
	else
		root["@tsed/json-mapper"] = factory(root["@tsed/core"], root["@tsed/schema"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__414__, __WEBPACK_EXTERNAL_MODULE__538__) => {
return 